import React from 'react';
import parse from 'html-react-parser';

export default function DisplayLinkImage(imageUrl?: string, includeEmptySpace?: boolean): string | JSX.Element | JSX.Element[] {
  let image = imageUrl ?? "";
  return image.trim().length > 0
    ? <> {parse(image)}{includeEmptySpace ?? true ? <>&nbsp;</> : <></>}</>
    : <></>
}
